import { OrdersList } from 'components/orders/OrdersList/OrdersList'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { appSelectors } from 'store/app'

export const Orders: React.FC = () => {
  const sellerId = useAppSelector(appSelectors.selectSellerId)
  return <OrdersList sellerId={sellerId ?? ''} />
}